import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LazyBulkEditorEducationModal } from "@faire/retailer-visitor-shared/features/PointOfSale/components/NotificationModals/LazyBulkEditorEducationModal";
import { LazyNewSettingNotifyModal } from "@faire/retailer-visitor-shared/features/PointOfSale/components/NotificationModals/LazyNewSettingNotifyModal";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { useMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useAppModal } from "@faire/retailer-visitor-shared/stores/ui/AppModalStore";
import { usePromoModalToDisplay } from "@faire/retailer-visitor-shared/stores/ui/PromoModalStore";
import { Typography } from "@faire/web--source/slate/Typography";
import { PageLoader } from "@faire/web--source/ui/CircleSpinner";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { HAS_SEEN_POS_NEW_FEATURE_MODAL } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/HAS_SEEN_POS_NEW_FEATURE_MODAL";
import { POS_BULK_EDITOR_EDUCATION_MODAL_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/POS_BULK_EDITOR_EDUCATION_MODAL_SEEN";
import pointOfSale from "@faire/web-api--source/routes/point-of-sale";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";
export var SummaryWall = function(param) {
    var _param_linkedOnly = param.linkedOnly, linkedOnly = _param_linkedOnly === void 0 ? false : _param_linkedOnly, _param_allowNotifications = param.allowNotifications, allowNotifications = _param_allowNotifications === void 0 ? false : _param_allowNotifications, children = param.children;
    var _usePOSSummary = usePOSSummary(), isLoading = _usePOSSummary.isLoading, isError = _usePOSSummary.isError, hasLinkedPOS = _usePOSSummary.hasLinkedPOS;
    var isModalShowing = useAppModal().isModalShowing;
    var modalToDisplay = usePromoModalToDisplay().modalToDisplay;
    var shouldShowNotificationModal = allowNotifications && hasLinkedPOS && !isModalShowing && !modalToDisplay;
    if (isLoading) {
        return /*#__PURE__*/ _jsx(PageLoader, {});
    }
    if (isError) {
        return /*#__PURE__*/ _jsx(Typography, {
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "8GvVWZ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Something went wrong, please try again."
                    }
                ]
            })
        });
    }
    return linkedOnly && !hasLinkedPOS ? /*#__PURE__*/ _jsx(Redirect, {
        to: pointOfSale()
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            shouldShowNotificationModal ? /*#__PURE__*/ _jsx(NotificationModal, {}) : null
        ]
    });
};
var NotificationModal = function() {
    var _useMilestone = useMilestone(HAS_SEEN_POS_NEW_FEATURE_MODAL), variantsModalSeen = _useMilestone.hasOccurred;
    var _useMilestone1 = useMilestone(POS_BULK_EDITOR_EDUCATION_MODAL_SEEN), bulkEditorModalSeen = _useMilestone1.hasOccurred;
    if (!bulkEditorModalSeen) {
        return /*#__PURE__*/ _jsx(Suspense, {
            children: /*#__PURE__*/ _jsx(LazyBulkEditorEducationModal, {})
        });
    }
    if (!variantsModalSeen) {
        // This component and the associated milestone have been poorly named
        // Won't change it as they should soon be removed
        return /*#__PURE__*/ _jsx(Suspense, {
            children: /*#__PURE__*/ _jsx(LazyNewSettingNotifyModal, {})
        });
    }
    return null;
};
